const categories = [
  { name: 'Shoes', sub: 'Sneakers & more', url: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line' },
  { name: 'Hoodies / Sweaters', sub: 'Cozy streetwear', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-t-shirt-line' },
  { name: 'T-Shirts', sub: 'Essential basics', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-t-shirt-air-line' },
  { name: 'Jackets', sub: 'Outerwear styles', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-cloud-windy-line' },
  { name: 'Pants / Shorts', sub: 'Bottoms collection', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-men-line' },
  { name: 'Headwear', sub: 'Hats & caps', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', icon: 'ri-base-station-line' },
  { name: 'Sets', sub: 'Complete outfits', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-stack-line' },
  { name: 'Underwear / Underpants', sub: 'Essentials', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-shirt-line' },
  { name: 'Jersey', sub: 'Sport & team wear', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-trophy-line' },
  { name: 'Accessories', sub: 'Finishing touches', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-glasses-line' },
  { name: 'Bags', sub: 'Backpacks & more', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-briefcase-line' },
  { name: 'Belts', sub: 'Waist accessories', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-links-line' },
  { name: 'Perfumes', sub: 'Fragrance picks', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-contrast-drop-line' },
  { name: 'Other Stuff', sub: 'More discoveries', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-line' },
];

export default function CategorySection() {
  return (
    <section id="categories" className="w-full px-4 md:px-8 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-10 gap-4">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-800 text-xs font-medium tracking-wide mb-3">
              Shop by Category
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950">
              Browse All <span className="text-primary-500">Categories</span>
            </h2>
            <p className="text-sm text-foreground-600 mt-2 max-w-md">
              Jump to your favorite finds on our main platform. Every category is updated weekly.
            </p>
          </div>
          <span className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-foreground-900 text-background-50 text-xs font-medium whitespace-nowrap">
            <i className="ri-grid-line text-xs"></i>
            14 Categories
          </span>
        </div>

        {/* Category Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center p-4 md:p-5 rounded-lg bg-background-100 hover:bg-background-200 transition-all duration-200 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-accent-100 flex items-center justify-center mb-3 group-hover:bg-accent-200 transition-colors">
                <i className={`${cat.icon} text-lg md:text-xl text-accent-600`}></i>
              </div>
              <span className="text-sm font-semibold text-foreground-900 text-center whitespace-nowrap group-hover:text-primary-600 transition-colors">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-500 mt-0.5 text-center">
                {cat.sub}
              </span>
              <span className="text-xs text-accent-600 font-medium mt-2 opacity-0 group-hover:opacity-100 transition-opacity flex items-center gap-0.5">
                View Deals
                <i className="ri-arrow-right-up-line text-[10px]"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}